// removed by extract-text-webpack-plugin
module.exports = {"arrowWrapper":"_11crEYEeurZz2KKc32uvFG","sliderItem":"_1lBzEHVLlqtjfVGWCLw-AT","prevArrow":"_3YUXZHP4PIxe68x26DXCEL","nextArrow":"_2TSU7xMtNFrOnJEbTOjh17"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePagePropertiesCarousel/HomePagePropertiesCarousel.scss
// module id = 316
// module chunks = 0